module.exports = __webpack_public_path__ + "assets/img/38fa70f0df673c60683e0d6a80c65c6d.svg";